module.exports = __webpack_public_path__ + "img/bots_empty.ef899159.svg";